export default __webpack_public_path__ + "static/media/blog-img228.7c430fea.jpg";